import React from 'react';

const RulesOfOperationPage = () => {
    return (
        <>
            <h3>PREVÁDZKOVÝ PORIADOK</h3>
            <p className={'my-3'}>vypracovaný v súlade s zákonom č. 355/2007 Z. z. o ochrane, podpore a rozvoji
                verejného zdravia a o zmene a doplnení niektorých zákonov a vyhláškou MZ SR č. 525/2007 Z. z. o
                podrobnostiach o požiadavkách na telovýchovno-športové zariadenia</p>
            <br/>
            <p className={'my-3'}>
                <h4>Identifikačné údaje prevádzkovateľa zariadenia:</h4>
                Názov a adresa zariadenia: FORMA – Fitness & Gym, Rovenská 668/2, 905 01 Senica<br/><br/>
                Obchodné meno prevádzkovateľa: rovenski s. r. o.,<br/><br/>
                Sídlo prevádzkovateľa: Rovenská 668/2, 905 01 Senica<br/><br/>
                IČO prevádzkovateľa: 56703236<br/>
                DIČ prevádzkovateľa: 2122397013<br/><br/>
                Spoločnosť zapísaná v Obchodnom registri Okresného súdu Trnava, odd. Sro, vložka č. 58356/T<br/><br/>
            </p>

            <p className={'my-3'}>
                <h4>Zodpovedný vedúci:</h4>
                <h5>Michal Šúrek</h5>
                Tel.: 0917 461 735<br/>
                E-mail: info@formafitness.sk<br/>
            </p>

            <p className={'my-3'}>
                <h4>Otváracie hodiny:</h4>
                Pondelok - Nedeľa: podľa objednávok (vstup podľa vytvorenej rezervácie v aplikácii iClub)<br/>
            </p>

            <p className={'my-3'}>
                <h4>Maximálna kapacita fitness priestoru:</h4>
                Maximálna kapacita fitness priestoru je 5 osôb súčasne (Open Gym), resp. 6 osôb súčasne (Skupinový
                tréning). Rezervačný systém neumožní vytvorenie rezervácie nad rámec tejto kapacity.
            </p>

            <p className={'my-3'}>
                <h4>Druh a spôsob poskytovaných služieb:</h4>
                <ul>
                    <li>Základnou poskytovanou službou je 60-minútový vstup Klienta do Priestorov FORMA – Fitness &
                        Gym, za účelom individuálneho cvičenia a športovej aktivity (ďalej len „vstup“). Táto služba
                        oprávňuje Klienta využívať priestory určené na cvičenie, ako aj šatne a hygienické zariadenia, a
                        to v súlade s podmienkami bežného užívania a VOP.
                    </li>
                    <li>Prevádzka funguje ako samoobslužné fitness centrum, bez stálej prítomnosti zástupcu
                        Prevádzkovateľa počas otváracích hodín.
                    </li>
                    <li>Vstup do Priestorov centra je možný iba prostredníctvom aplikácie iClub.sk, a to najskôr 15
                        minút pred samotným začiatkom rezervovanej Služby.
                    </li>
                    <li>Rezervácia Služby je podmienená dostupnou kapacitou a dostatočným Kreditom Klienta na jeho
                        Konte.
                    </li>
                </ul>
            </p>

            <p className={'my-3'}>
                <h4>Zakázané úkony pri poskytovaní služieb:</h4>
                <ul>
                    <li>Zákaz fajčenia v celom areáli prevádzky.</li>
                    <li>Zákaz vnášania skla (vrátane fliaš).</li>
                    <li>Zákaz fotografovania a filmovania bez súhlasu prevádzkovateľa.</li>
                    <li>Zákaz používania zbraní.</li>
                    <li>Zákaz skladovania osobných vecí mimo určených skriniek.</li>
                    <li>Zákaz používania kozmetiky mimo šatní a spŕch.</li>
                    <li>Zákaz nadmerného hluku a rušenia ostatných klientov.</li>
                </ul>
            </p>
            <p className={'my-3'}>
                <h4>Zákaz vstupu do prevádzky majú:</h4>
                <ul>
                    <li>Osoby pod vplyvom alkoholu alebo drog.</li>
                    <li>Osoby s akútnym infekčným alebo kožným ochorením, ktoré by mohlo ohroziť zdravie ostatných
                        klientov.
                    </li>
                    <li>Osoby so zvieratami.</li>
                    <li>Osoby porušujúce prevádzkový poriadok.</li>
                    <li>Osoby, ktoré využívajú priestory na iné než športové účely bez súhlasu prevádzkovateľa.
                    </li>
                    <li>Klienti s chronickým ochorením (napr. srdcovo-cievnym alebo neurologickým, vrátane
                        epilepsie) cvičia na vlastnú zodpovednosť. Odporúčame im pred začatím cvičenia konzultovať
                        vhodnosť fyzickej záťaže s ošetrujúcim lekárom a necvičiť osamote v čase mimo prevádzkových
                        hodín s prítomnou obsluhou, ak taká existuje.
                    </li>
                </ul>
                Prevádzkovateľ alebo ním poverená osoba je oprávnená
                vyzvať tieto osoby na opustenie priestorov.
                V prípade neuposlúchnutia môže byť privolaná polícia.
            </p>

            <p className={'my-3'}>
                <h4>Podmienky prevádzky a dispozičné riešenie priestorov:</h4>

                Prevádzka tvorí uzatvorený celok:
                <ul>
                    <li>Vstupná hala so vstupom do WC (muži/ženy) a recepcie.</li>
                    <li>WC muži s predsienkou, kde sa nachádza umývadlo s vodovodnou batériou s teplou a studenou vodou,
                        1ks pisoár a 1 ks záchodová misa. Je prístupné z priestoru vstupnej haly.
                    </li>
                    <li>WC ženy s predsienkou, kde sa nachádza umývadlo s vodovodnou batériou s teplou a studenou vodou,
                        1 ks záchodová misa. Je prístupné z priestoru vstupnej haly.
                    </li>
                    <li>Recepcia so vstupom do šatní (muži/ženy) a fitness priestoru, nachádza sa tu pult s PC,
                        hygienická stanica.
                    </li>
                    <li>Šatne muži - vybavené uzamykateľnými skrinkami na uloženie vecí, sprchou a umývadlom, a
                        technickou miestnosťou.
                    </li>
                    <li>Šatne ženy - vybavené uzamykateľnými skrinkami na uloženie vecí, sprchou a umývadlom.</li>
                    <li>Fitness priestor - vstup z recepcie, vybavený: Airbike, veslársky trenažér, rebriny,
                        posilňovacia kladka, posilňovacia klietka, jednoručné činky, kettlebelly, olympijské osy,
                        podložky, zrkadlá, medicinbaly, fitlopty, posilňovacie náradie, minibandy, lavice, server.
                    </li>
                </ul>
                Inžinierske siete:
                <ul>
                    <li>Objekt je napojený na verejné inžinierske siete mesta.</li>
                    <li>Pitná voda (verejný vodovod v správe Bratislavskej vodárenskej spoločnosti a.s., Bratislava).
                    </li>
                    <li>Kontrola kvality pitnej vody je vykonávaná 1 x ročne.</li>
                    <li>Odkanalizovanie je riešené napojením objektu na verejnú kanalizáciu mesta.</li>
                    <li>Príprava teplej vody – elektrický bojler, umiestnený v technickej miestnosti.</li>
                </ul>
                Vykurovanie:
                <ul>
                    <li>Je riešené klimatizáciami, ako záložný zdroj je kotol na tuhe palivo napojený na radiátorový
                        systém.
                    </li>
                </ul>
                Osvetlenie:
                <ul>
                    <li>Prirodzené a umelé.</li>
                </ul>
                Vetranie:
                <ul>
                    <li>Fitness centrum je vybavené systémom vzduchotechniky a klimatizácie zabezpečujúcim výmenu
                        vzduchu v
                        súlade s hygienickými normami. Teplota a vlhkosť v cvičebných priestoroch sú udržiavané v súlade
                        s
                        vyhláškou MZ SR č. 259/2008 Z. z. (ideálne 18–22 °C).
                    </li>
                </ul>
                Kamerový systém:
                <ul>
                    <li>Priestor prevádzky je monitorovaný kamerovým systémom so záznamom.</li>
                    <li>Klienti berú na vedomie, že priestory fitnesscentra, najmä priestory vstupu, recepcia a cvičebný
                        priestor sú monitorované kamerovým systémom na účely:
                        <ul>
                            <li>Bezpečnosti zdravia a majetku prevádzkovateľa a jeho klientov,</li>
                            <li>Uplatňovania, obhajovania a preukazovania právnych nárokov prevádzkovateľa.</li>
                        </ul>
                    </li>
                </ul>
                Podrobnosti o kamerovom systéme sú v Informácii o spracúvaní osobných údajov.<br/><br/>

                Núdzové situácie:
                <ul>
                    <li>V prevádzke nie je počas otváracích hodín trvalo prítomný personál. V prípade úrazu alebo
                        zdravotnej núdze klient bezodkladne volá tiesňovú linku 112. Priestor je monitorovaný
                        kamerovým systémom. Akúkoľvek udalosť klient bezodkladne nahlási zodpovednému vedúcemu na
                        tel. 0917 461 735 alebo e-mailom na info@formafitness.sk. Klientom sa odporúča necvičiť v
                        neskorých nočných hodinách osamote a informovať blízku osobu o svojej návšteve fitness
                        centra.
                    </li>
                </ul>
            </p>
            <p className={'my-3'}>
                <h4>Režim prevádzky - podmienky prevádzky a zásady ochrany zdravia klientov</h4>
                <ul>
                    <li>Podlaha vo fitness priestore je gumená, ľahko čistiteľná a nekĺzavá.</li>
                    <li>Steny sú hladké bez výstupkov.</li>
                    <li>Vnútorné povrchy nie sú lesklé, farebné riešené je zvolené tak, aby nezhoršovali svetelné
                        podmienky.
                    </li>
                </ul>
            </p>
            <p className={'my-3'}>
                <h4>Pravidlá prevádzky:</h4>
                <ul>
                    <li>Vstup je povolený len registrovaným klientom.</li>
                    <li>Deti do 18 rokov majú povolený vstup len v sprievode zákonného zástupcu.</li>
                    <li>Povinnosť mať čistú športovú obuv, vhodné športové oblečenie a uterák.</li>
                    <li>Neodporúča sa cvičiť chorým osobám.</li>
                    <li>Zákaz používania zariadení inak než podľa ich účelu.</li>
                    <li>Po cvičení je povinné vrátiť náradie na pôvodné miesto.</li>
                    <li>Povinnosť očistiť a dezinfikovať zariadenie po použití.</li>
                    <li>Šatňové skrinky neslúžia na úschovu cenností.</li>
                </ul>
            </p>
            <p className={'my-3'}>
                <h4>Pokyny pre klientov:</h4>
                <ul>
                    <li>Zaregistrovaný klient sa v aplikácii prihlási na vybranú službu v určitý termín.</li>
                    <li>Po príchode ku vstupným dverám si na mobilnom telefóne otvorí aplikáciu iClub a priloží
                        pridelený QR kód k čítačke pri dverách.
                    </li>
                    <li>Po zaznený zvukového signálu sú dvere odomknuté a klient vstúpi do prevádzky.</li>
                    <li>Klient si odkladá obuv v určených priestoroch vstupnej haly.</li>
                    <li>Na prezliekanie a odloženie osobných vecí slúžia šatne.</li>
                    <li>Po odcvičení/vypršaní rezervovaného času (podľa toho, čo nastane skôr) je klient povinný opustiť
                        prevádzku.
                    </li>
                </ul>
            </p>
            <p className={'my-3'}>
                <h4>Prvá pomoc:</h4>
                <ul>
                    <li>V zariadení sa nachádza lekárnička, vybavená v zmysle platných právnych predpisov SR, umiestnená
                        v priestore recepcie na viditeľnom, voľne prístupnom mieste.
                    </li>
                </ul>
            </p>
            <p className={'my-3'}>
                <h4>Vybavenie lekárničky:</h4>
                <ul>
                    <li>(5 ks Dezinfekčné utierky 0,2% chlórhexidín, 1 ks Výplach očí STEROWASH - jednorazový 20 ml, 3
                        ks Hotový
                        obväz s 1 vankúšikom, 3 ks Hotový obväz s 2 podložkami, 1 ks Celulózová vata, 5 x 4 cm / 10 ks,
                        1 ks Náplasť
                        - rýchloobväz 6 cm x 1 m, 1 ks Náplasť s poštárom 8 x 4 cm (6 ks/balenie), 1 ks Krycia plachta -
                        rúško 20 x
                        20 cm, 1 ks Izotermická fólia 200 x 140 cm strieborná / strieborná, 1 ks Hladká cievková náplasť
                        2,5 cm x 5
                        m, 1 ks Gumová škrtiaca bandáž 6 cm x 125 cm, 1 ks Trojcípa šatka 96 cm x 96 cm x 136 cm, 1 ks
                        Gumové
                        /latexové/chirurgické rukavice v balení - 1 pár, 1 ks Nožnice so šikmými, zaoblenými hrotmi -
                        min. dĺžka 14
                        cm, 1 ks Karta prvej pomoci).
                    </li>
                </ul>
            </p>
            <p className={'my-3'}>
                <h4>Zodpovednosť prevázkovateľa</h4>
                <ul>
                    <li>Prevádzkovateľ nezodpovedá za škodu na veciach vnesených alebo odložených v prevádzke počas
                        využívania
                        služieb.
                    </li>
                    <li>Návštevníci používajú všetky zariadenia a vybavenie prevádzky na vlastné riziko. Prevádzkovateľ
                        nezodpovedá za škody na zdraví, ktoré si návštevník spôsobí sám, najmä v dôsledku nedodržania
                        prevádzkového
                        poriadku, pokynov zodpovedných osôb alebo nesprávneho používania zariadení.
                    </li>
                    <li>Prevádzkovateľ nezodpovedá za úrazy spôsobené inou osobou, alebo ktoré vznikli v dôsledku
                        porušenia
                        povinností tretích osôb.
                    </li>
                    <li>V prípade zranenia alebo nehody je návštevník povinný túto skutočnosť bezodkladne oznámiť
                        prevádzkovateľovi (alebo ním poverenej osobe), aby bolo možné zabezpečiť riadne zdokumentovanie
                        a pomoc.
                    </li>

                </ul>
            </p>

            <p className={'my-3'}>
                <h4>Požiarna bezpečnosť</h4>
                <ul>
                    <li>Prevádzka je vybavená hasiacimi prístrojmi v súlade s požiarnymi predpismi.</li>
                    <li>Únikový východ je riadne označený a trvalo voľný.</li>
                </ul>
            </p>

            <p className={'my-3'}>
                <h4>Spôsob a frekvencia upratovania zariadenia</h4>
                <ul>
                    <li>Na zabezpečenie ochrany zdravia klientov sú v priestoroch prevádzky k dispozícii čistiace
                        prostriedky na
                        dezinfekciu zariadení po použití.
                    </li>

                    <li>V prípade výskytu podozrenia na výskyt infekčného ochorenia budú priestory okamžite
                        dezinfikované a
                        prevádzka môže byť dočasne uzavretá.
                    </li>
                </ul>
                <h5>Postup pri mechanickej očiste a dezinfekcii povrchových plôch miestnosti a zariaďovacích
                    predmetov:</h5>
                Pri dezinfekcii povrchov sa zachováva dvojetapový postup – najskôr mechanická očista potom vlastná
                dezinfekcia.<br/><br/>

                Mechanická očista – predstavuje súbor opatrení, ktorým sa na vlhko a za použitia povrchovo aktívnych
                látok
                (detergenty – mydlá, saponáty) mechanicky odstraňujú mikroorganizmy z povrchov plôch, predmetov a
                pomôcok.
                Mechanická očista predchádza dezinfekcii.<br/><br/>

                Dezinfekcia – založená najmä na pôsobení chemických látok schopných po určitej dobe pôsobenia likvidovať
                patogénne baktérie.<br/><br/>

                V prevádzke sú používané dezinfekčné prostriedky: Savo, Savo WC, Domestos, Sanytol, Fixinela a čistiace
                prostriedky.

                <h5>Zásady bezpečnosti pri práci s dezinfekčnými roztokmi:</h5>
                Pri práci s dezinfekčnými prostriedkami a ich roztokmi je potrebné dodržiavať zásady ochrany zdravia a
                bezpečnosti pri práci. Je nevyhnutné používať ochranné pracovné prostriedky. Úplne základné je potrebné
                chrániť pokožku rúk rukavicami, oči zvlášť pri riedení koncentrátov okuliarami. Aby nedošlo k požitiu
                dezinfekčného prostriedku nesmie sa pri práci s ním jesť, piť a fajčiť. Pri rozsiahlych aplikáciách
                dezinfekčných prostriedkov je potrebné dobre vetrať. Po práci sa ruky umyjú a ošetria regeneračným
                krémom.
                Dezinfekčné prostriedky sa skladujú v uzavretých originálnych obaloch. Nikdy sa na skladovanie
                dezinfekčných
                prostriedkov nepoužívajú obaly od potravín alebo nápojov ako náhradné obaly! Skladovacie priestory musia
                byť
                suché, čisté a chladné, bez dosahu priameho slnečného svetla. Dezinfekcia sa skladuje oddelene od
                potravín a
                iných chemikálií: technická miestnosť v pánskej šatni. Prázdne obaly sa vyplachujú vodou. Zbytky
                koncentrátov sa likvidujú nariedením vodou a vyliatím do odpadu.

                <h5>Faktory pracovného prostredia (faktor spolu s možným zdrojom) pôsobiace izolovane, spolupôsobiace,
                    prípadne
                    s možným vplyvom na už existujúce neprofesionálne poškodenia zdravia:</h5>

                A. Chemické faktory:
                <ul>
                    <li>dezinfekčné prostriedky: dráždivý účinok na pokožku a respiračný systém, alergizujúci účinok
                    </li>
                    <li>ochrana horných dýchacích ciest – zabezpečené prirodzené vetranie</li>
                </ul>

                B. Preventívne opatrenia:
                <ul>
                    <li>ochrana pred možným kontaktom používaného dezinfekčného prostriedku s pokožkou je zabezpečená
                        používaním
                        ochranných rukavíc
                    </li>
                    <li>práca s prípravkami podľa doporučení výrobcu, tak ako sú uvedené u jednotlivých používaných
                        dezinfekčných prostriedkov a používanie osobných ochranných pomôcok
                    </li>
                </ul>

                V prípade objavenia sa nových skutočností, ak to bude potrebné, zabezpečím všetky objektivizácie
                škodlivých/potencionálne škodlivých faktorov pracovného prostredia podľa usmernenia a požiadaviek
                pracovníkov RÚVZ Senica.

                <h5>Spôsob a frekvencia upratovania zariadenia :</h5>
                Upratovanie spoločných priestorov je vykonávané denne. Najmenej raz za štvrťrok sa vykonáva všeobecné
                upratovanie spojené s umytím okien, dverí, svietidiel . Vo všetkých miestnostiach sa denne utiera prach
                navlhko, vetrajú sa miestnosti. Podlahy sa umývajú denne za použitia prípravku Sanytol na podlahy, podľa
                návodu na obale výrobku. V sprchách a WC sa denne vykonáva umývanie podláh, ostatných plôch,
                zariaďovacích
                predmetov s následnou dezinfekciou. V sprchách sa používa na dezinfekciu protiplesňový prípravok Savo.

                <h5>Frekvencia upratovania:</h5>
                <ul>
                    <li>Vysávanie, mopovanie, dezinfekcia dotykových plôch, podlahových plôch a WC: denne</li>
                    <li>Vynášanie odpadov: odstraňované denne</li>
                    <li>Šatne: dezinfikované po upratovaní a pri znečistení</li>
                    <li>Osvetlenie: min. 1× za štvrťrok alebo pri potrebe</li>
                    <li>Okná: min. 1× mesačne alebo podľa potreby</li>
                </ul>

                <h5>Spôsob nakladania s odpadom, jeho odstraňovanie, frekvencia vyprázdňovania odpadových nádob, ich
                    čistenie a
                    dezinfekcia:</h5>

                Pre zhromažďovanie odpadu sú umiestnené v recepcii, v šatniach a wc uzavreté odpadkové koše opatrené
                jednorázovými vreckami na odpad. Tieto vrecká sú denne odnášané do kontajnera na tuhý komunálny odpad a
                odpadové koše sa dezinfikujú Savom. Mechanická očista a dezinfekcia je vykonávaná jeden krát týždenne
                dezinfekčným prípravkom (SAVO).
            </p>

            <p className={'my-3'}>
                <h4>Sankcie a reklamácie</h4>
                <ul>
                    <li>Porušenie prevádzkového poriadku môže viesť k blokovaniu účtu (dočasné/trvalé) zo strany
                        prevádzkovateľa,
                        čo znemožní klientovi vstup do prevádzky a využívaniu jeho služieb.
                    </li>
                    <li>
                        Hrubé porušenia pprevádzkového poriadku môže viesť k privolaniu a zásahu polície.
                    </li>
                    <li>
                        Reklamácie: e-mailom na info@formafitness.sk .
                    </li>
                </ul>
            </p>

            <p className={'my-3'}>
                <h4>Osobitné ustanovenia</h4>
                Prevádzkový poriadok zariadenia je vyvesený na viditeľnom mieste – recepcia, voľne prístupný pre
                klientov
                zariadenia. Prevádzkový poriadok bude pravidelne aktualizovaný na základe možných zmien a skutočností
                pri
                prevádzkovaní a predložený na opätovné posúdenie orgánu na ochranu zdravia. V prípade objavenia sa
                nových
                skutočností, ak to bude potrebné, zabezpečím všetky objektivizácie škodlivých/potencionálne škodlivých
                faktorov pracovného prostredia podľa usmernenia a požiadaviek pracovníkov RÚVZ Senica.
            </p>

            <p className={'my-3'}>
                <h4>Záverečné ustanovenia</h4>
                <ul>
                    <li>Za dodržiavanie uvedených ustanovení a striktné plnenie povinností z nich vyplývajúcich
                        zodpovedá
                        prevádzkovateľ. Je povinný denne vykonávať prehliadku všetkých pracovných priestorov a posúdiť
                        prevádzkyschopnosť zariadenia na poskytovanie služieb.
                    </li>
                    <li>Prevádzkovateľ si vyhradzuje právo meniť a aktualizovať prevádzkový poriadok.</li>
                    <li>Aktuálna verzia je dostupná na recepcii a v aplikácii.</li>
                    <li>Klient registráciou v aplikácii potvrdzuje oboznámenie sa s týmto dokumentom a súhlasí so
                        spracúvaním
                        osobných údajov v rozsahu nevyhnutnom na prevádzku fitness centra, a to v súlade s nariadením
                        GDPR a zákonom
                        č. 18/2018 Z. z.
                    </li>
                </ul>
                Tento Prevádzkový poriadok je účinný od 01. 08. 2026.
            </p>
            Vypracované v Senici, dňa: 16. 07. 2026<br/><br/>
            <b>Michal Šúrek</b><br/>
            konateľ rovenski s. r. o.
        </>
    );
}

export default RulesOfOperationPage;
